import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [{
    path: '/Login',
    component: resolve => require(['@/page/Login.vue'], resolve),
  }, {
    path: '/',
    component: resolve => require(['@/page/index.vue'], resolve),
    redirect: '/article/article_list',
    children: [
      {
        path: '/case/add_case',
        name: '/case/case_list',
        component: resolve => require(['@/page/case/add_case.vue'], resolve),
      },
      {
        path: '/case/case_list',
        name: '/case/case_list',
        component: resolve => require(['@/page/case/case_list.vue'], resolve),
      },
      {
        path: '/member/add_member',
        name: '/member/member_list',
        component: resolve => require(['@/page/member/add_member.vue'], resolve),
      },
      {
        path: '/member/member_list',
        name: '/member/member_list',
        component: resolve => require(['@/page/member/member_list.vue'], resolve),
      },
      {
        path: '/address/address',
        name: '/address/address',
        component: resolve => require(['@/page/address/address.vue'], resolve),
      },
      {
        path: '/address/add_address',
        name: '/address/address',
        component: resolve => require(['@/page/address/add_address.vue'], resolve),
      },
      {
        path: '/article/article_list',
        name: '/article/article_list',
        component: resolve => require(['@/page/article/article_list.vue'], resolve),
      },
      {
        path: '/article/add_article',
        name: '/article/article_list',
        component: resolve => require(['@/page/article/add_article.vue'], resolve),
      },
      {
        path: '/article/transaction',
        name: '/article/transaction',
        component: resolve => require(['@/page/article/transaction.vue'], resolve),
      },
      {
        path: '/article/add_transaction',
        name: '/article/transaction',
        component: resolve => require(['@/page/article/add_transaction.vue'], resolve),
      },
      {
        path: '/article/news',
        name: '/article/news',
        component: resolve => require(['@/page/article/news.vue'], resolve),
      },
      {
        path: '/article/add_news',
        name: '/article/news',
        component: resolve => require(['@/page/article/add_news.vue'], resolve),
      },
      {
        path: '/article/media',
        name: '/article/media',
        component: resolve => require(['@/page/article/media.vue'], resolve),
      },
      {
        path: '/article/add_media',
        name: '/article/media',
        component: resolve => require(['@/page/article/add_media.vue'], resolve),
      },
      {
        path: '/tag/case',
        name: '/tag/case',
        component: resolve => require(['@/page/tag/case.vue'], resolve),
      },
      {
        path: '/tag/add_case',
        name: '/tag/case',
        component: resolve => require(['@/page/tag/add_case.vue'], resolve),
      },
      {
        path: '/recruit/recruit',
        name: '/recruit/recruit',
        component: resolve => require(['@/page/recruit/recruit.vue'], resolve),
      },
      {
        path: '/recruit/add_recruit',
        name: '/recruit/recruit',
        component: resolve => require(['@/page/recruit/add_recruit.vue'], resolve),
      },
      {
        path: '/tag/recruit',
        name: '/tag/recruit',
        component: resolve => require(['@/page/tag/recruit.vue'], resolve),
      },
      {
        path: '/tag/add_recruit',
        name: '/tag/recruit',
        component: resolve => require(['@/page/tag/add_recruit.vue'], resolve),
      },
      {
        path: '/tag/depth',
        name: '/tag/depth',
        component: resolve => require(['@/page/tag/depth.vue'], resolve),
      },
      {
        path: '/tag/add_depth',
        name: '/tag/depth',
        component: resolve => require(['@/page/tag/add_depth.vue'], resolve),
      },
      {
        path: '/depth/depth',
        name: '/depth/depth',
        component: resolve => require(['@/page/depth/depth.vue'], resolve),
      },
      {
        path: '/depth/add_depth',
        name: '/depth/depth',
        component: resolve => require(['@/page/depth/add_depth.vue'], resolve),
      }, {
        path: '/address/value',
        name: '/address/value',
        component: resolve => require(['@/page/address/value.vue'], resolve),
      },{
        path: '/address/industry',
        name: '/address/industry',
        component: resolve => require(['@/page/address/industry.vue'], resolve),
      },{
        path: '/address/add_industry',
        name: '/address/add_industry',
        component: resolve => require(['@/page/address/add_industry.vue'], resolve),
      },{
        path: '/address/iconlist',
        name: '/address/iconlist',
        component: resolve => require(['@/page/address/iconlist.vue'], resolve),
      },{
        path: '/address/add_icon',
        name: '/address/add_icon',
        component: resolve => require(['@/page/address/add_icon.vue'], resolve),
      },{
        path: '/tag/financing',
        name: '/tag/financing',
        component: resolve => require(['@/page/tag/financing.vue'], resolve),
      },{
        path: '/tag/add_financing',
        name: '/tag/add_financing',
        component: resolve => require(['@/page/tag/add_financing.vue'], resolve),
      },
    ]
  }],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js